import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import WishlistToggleButton from '~/shared/components/WishlistToggleButton';
import { useSession } from '~/techstyle-shared/redux-core';

const FavoriteButtonWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
`;

const ProductCardFavoriteButton = ({ product }) => {
  const { isLoggedIn } = useSession();

  if (!isLoggedIn) {
    return null;
  }

  return (
    <FavoriteButtonWrapper>
      <WishlistToggleButton
        data-cnstrc-btn="add-to-favorites"
        product={product}
        variant="large-white-heart"
        autoTagPrefix="product-card"
      />
    </FavoriteButtonWrapper>
  );
};

ProductCardFavoriteButton.propTypes = {
  product: PropTypes.object.isRequired,
};

export default ProductCardFavoriteButton;
